/**
 * Setup react-i18next pour le PORTAIL client NIS365.
 *
 * Configuration MINIMALE basée sur la doc officielle i18next, sans options
 * exotiques. 4 langues : fr-BE / nl-BE / de-BE / en.
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import frBE from './locales/fr-BE.json';
import nlBE from './locales/nl-BE.json';
import deBE from './locales/de-BE.json';
import en   from './locales/en.json';

export const SUPPORTED_LANGUAGES = [
  { code: 'fr-BE', label: 'FR', longLabel: 'Français (BE)',   flag: '🇧🇪' },
  { code: 'nl-BE', label: 'NL', longLabel: 'Nederlands (BE)', flag: '🇧🇪' },
  { code: 'de-BE', label: 'DE', longLabel: 'Deutsch (BE)',    flag: '🇧🇪' },
  { code: 'en',    label: 'EN', longLabel: 'English',         flag: '🇪🇺' },
] as const;

export type LangCode = typeof SUPPORTED_LANGUAGES[number]['code'];

const STORAGE_KEY = 'nis365-portal-lang';

function detectInitialLang(): LangCode {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored && (['fr-BE','nl-BE','de-BE','en'] as string[]).includes(stored)) {
      return stored as LangCode;
    }
  } catch { /* mode prive */ }

  const nav = (navigator.language || 'fr-BE').toLowerCase();
  if (nav.startsWith('fr')) return 'fr-BE';
  if (nav.startsWith('nl')) return 'nl-BE';
  if (nav.startsWith('de')) return 'de-BE';
  if (nav.startsWith('en')) return 'en';
  return 'fr-BE';
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      'fr-BE': { translation: frBE },
      'nl-BE': { translation: nlBE },
      'de-BE': { translation: deBE },
      'en':    { translation: en   },
    },
    lng:           detectInitialLang(),
    fallbackLng:   'fr-BE',
    interpolation: { escapeValue: false },
  });

i18n.on('languageChanged', (lng) => {
  try { window.localStorage.setItem(STORAGE_KEY, lng); } catch { /* ignore */ }
});

export default i18n;
